import styled, { css } from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { theme } from "../v2/toyota/theme/toyotaTheme";

export const GreyBackground = styled.div<SpaceProps>`
    background-color: ${theme.colors.grey1};
    ${space};
`;

// Animation to get a moving loading background. Based on car-filter v1 layout.
export const loadingBackgroundCss = css`
    background: linear-gradient(
        45deg,
        ${theme.colors.grey1} 0%,
        ${theme.colors.primaryWhite} 33%,
        ${theme.colors.grey1} 66%,
        ${theme.colors.primaryWhite} 100%
    );
    background-size: 400% 400%;
    animation: AnimationName 2s linear infinite;
    @keyframes AnimationName {
        0% {
            background-position: 100% 0%;
        }
        100% {
            background-position: 15% 100%;
        }
    }
`;

export const Gradient = styled.div`
    background: linear-gradient(180deg, rgba(106, 107, 112, 0.1) 0%, ${theme.colors.primaryWhite} 100%);
`;
